//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { ICuralateSession } from 'app/basic-session/ICuralateSession';
import { crl8 } from 'app/curalate.globals';
import logger from 'app/logger/logger';

crl8.logger = logger;

crl8.logger.init(CURALATE_ENV.RELEASE, location.hostname);
void crl8.userSessionPromise.then((session) => {
  void crl8.logger.identify(
    session ?? ({} as ICuralateSession),
    CURALATE_ENV.IS_PRODUCTION_MODE,
  );
});
